import React from 'react';

const WalletCard = ({ balance }) => {
  const isNegative = parseFloat(balance) < 0;

  return (
    <div className="bg-thirdly rounded-xl shadow-sm p-6 flex items-center justify-between">
      <div>
        <h3 className="text-gray-100 text-sm font-medium uppercase tracking-wider">Current Wallet Balance</h3>
        <div className={`text-3xl font-bold mt-2 ${isNegative ? 'text-red-600' : 'text-green-600'}`}>
          {balance} <span className="text-sm text-gray-400 font-normal">SAR</span>
        </div>
      </div>
      <div className={`p-3 rounded-full ${isNegative ? 'bg-red-50 text-red-500' : 'bg-green-50 text-green-500'}`}>
        {/* Simple Wallet Icon */}
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      </div>
    </div>
  );
};

export default WalletCard;